
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 405 197","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#115AA5","d":"M0 0h405v197H0z"}}),_c('g',{attrs:{"opacity":".2"}},[_c('path',{attrs:{"d":"M-280.645 96.72v82.883l430.92 248.676v-82.882l-430.92-248.676z","fill":"#4780B2"}}),_c('path',{attrs:{"d":"M-137.016-69.074v82.913l287.291 165.763V96.72L-137.016-69.074z","fill":"#4780B2"}}),_c('path',{attrs:{"d":"M-128.086-240L-496.121-27.617v82.881L15.575-240h-143.661z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M150.273 96.721v82.882l497.726-287.209v-82.882L150.273 96.722z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M150.273 345.397v82.882l497.726-287.21V58.188L150.273 345.397z","fill":"#7598C1"}}),_c('path',{attrs:{"d":"M150.275 262.516L-280.645 13.84l-215.476 124.338L-711.596 13.84-922 135.255v82.881l210.435-121.415L-496.09 221.06l215.476-124.339 430.92 248.677L648 58.188v-82.881L150.306 262.516h-.031z","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M590.156-240L150.275 13.84-65.17-110.5l-71.846 41.425L150.275 96.721 648-190.49V-240h-57.844z","fill":"#B8C9DE"}})])])
          )
        }
      }
    